// 导入封装的方法
import {
  post
} from '../http'

const committeeWorkstation = {
  stationList (params) {
    return post('/work/station/manage/public/list', params)
  },
  publicInfo (params) {
    return post('/work/station/manage/public/info/' + params.id, params)
  },
  publicDdd (params) {
    return post('public/opinion/public/add', params)
  },
  publicList (params) {
    return post('public/opinion/public/list', params)
  }
}
export default committeeWorkstation
